import { useEffect, useState } from 'react';

interface PendingPhotoPreviewsProps {
  files: File[];
  onRemove(index: number): void;
}

interface PendingPreview {
  file: File;
  url: string;
}

export function PendingPhotoPreviews({ files, onRemove }: PendingPhotoPreviewsProps) {
  const [previews, setPreviews] = useState<PendingPreview[]>([]);

  useEffect(() => {
    const next = files.map((file) => ({ file, url: URL.createObjectURL(file) }));
    setPreviews(next);
    return () => next.forEach((preview) => URL.revokeObjectURL(preview.url));
  }, [files]);

  if (!previews.length) return null;

  return <div className="pending-photo-grid" aria-label="Fotografii selectate, nesalvate">
    {previews.map((preview, index) => <figure className="pending-photo-preview" key={`${preview.file.name}:${preview.file.lastModified}:${index}`}>
      <img src={preview.url} alt={`Fotografie selectată ${index + 1}`} />
      <figcaption>{preview.file.name}</figcaption>
      <button type="button" aria-label={`Elimină ${preview.file.name}`} onClick={() => onRemove(index)}>×</button>
    </figure>)}
  </div>;
}
